var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import LmsIntegrationService from "../../../Services/LmsIntegration.service";
import LmsIntegrationLookupModal from "./LmsIntegrationLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield LmsIntegrationService.search({
            query: search,
            searchText: options.searchText,
            ids: options.ids,
            excludeIds: options.excludeIds,
            displayNames: options.displayNames,
            internalNames: options.internalNames,
            descriptions: options.descriptions,
            modifiedDateTo: options.modifiedDateTo,
            modifiedDateFrom: options.modifiedDateFrom,
            createdDateTo: options.createdDateTo,
            createdDateFrom: options.createdDateFrom,
            orderBy: options.orderBy,
        }, {
            max: (_a = options.max) !== null && _a !== void 0 ? _a : 20,
            sort: options.sort,
            order: options.order,
            offset: options.offset,
        });
        return response.data;
    }),
    value: "id",
    label: "displayName",
};
export const LmsIntegrationSearch = makeSearch(makeSearchArgs);
export const LmsIntegrationMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: LmsIntegrationLookupModal }));
